<template>
  <div>
    <div v-if="isNeither">
      <p>You are not using a mobile device. However you can check out our apps on these app stores:</p>
      <ul>
        <li>
          <a :href="appStoreLink">Apple App Store</a>
        </li>
        <li>
          <a :href="playStoreLink">Google Play Store</a>
        </li>
      </ul>
    </div>
    <div v-else>
      <h1>
        Download Our App
      </h1>
      <p>
        Get the best experience on your mobile device. Download our app for iOS or Android.
      </p>
      <div>
        <a
          v-if="isIOS"
          :href="appStoreLink"
        >
          Download for iOS
        </a>
        <a
          v-if="isAndroid"
          :href="playStoreLink"
        >
          Download for Android
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceTypeMixin from '@/mixins/deviceType';

export default {
  mixins: [DeviceTypeMixin],
  computed: {
    appStoreLink() {
      return this.$store.getters['app/appStoreLink'];
    },
    playStoreLink() {
      return this.$store.getters['app/playStoreLink'];
    },
  },
  mounted() {
    if (this.isIOS) {
      // send them to the iOS app store
      window.location.href = this.appStoreLink;
    } else if (this.isAndroid) {
      // send them to the Android app store
      window.location.href = this.playStoreLink;
    }
  },
};
</script>
